import React from 'react';
import Leaves from './Leaves';

export default function LeaveCalendarModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 320,
        right: 0,
        bottom: 0,
        width: 'calc(100vw - 320px)',
        height: '100vh',
        zIndex: 100001,
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        background: 'rgba(4,10,13,0.72)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
      }}
      onClick={onClose}
    >
      <div
        style={{ display: 'flex', width: '100%', height: '100%', minWidth: 0 }}
        onClick={e => e.stopPropagation()}
      >
        <Leaves token={localStorage.getItem('token')} onClose={onClose} />
      </div>
    </div>
  );
}
